export enum EPlace {
	home = "home",
	center = "center"
}